import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'main',
        component: () => import('@/components/Main/mainComponent.vue'),
    },
    {
        path: '/ai-datacore',
        name: 'ai-datacore',
        component: () => import('@/views/AiDataCore.vue'),
    },
];
const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
});

router.afterEach(() => {
    const app = document.getElementById('app');
    if (app) app.scrollTop = 0;
});

export default router;